import { render, staticRenderFns } from "./SolutionPanel.vue?vue&type=template&id=20fabad3&scoped=true"
import script from "./SolutionPanel.vue?vue&type=script&lang=js"
export * from "./SolutionPanel.vue?vue&type=script&lang=js"
import style0 from "./SolutionPanel.vue?vue&type=style&index=0&id=20fabad3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fabad3",
  null
  
)

export default component.exports